/**
 * Moves the Stamped app slot into a native <dialog> on open and restores it on close (single widget instance).
 */
(function () {
  function initDialog(dialog) {
    var modalId = dialog.id;
    var sectionId = modalId.replace(/^ProductReviewsModal-/, '');
    var slot = document.getElementById('ProductReviewsAppSlot-' + sectionId);
    var body = dialog.querySelector('[data-reviews-modal-body]');
    if (!slot || !body) return;

    var openBtn = document.querySelector(
      '[data-reviews-modal-open][aria-controls="' + modalId + '"]'
    );
    var closeBtns = dialog.querySelectorAll('[data-reviews-modal-close]');
    var placeholder = null;

    function open() {
      if (!placeholder) {
        placeholder = document.createElement('div');
        placeholder.className = 'product-reviews-app-slot-placeholder';
        placeholder.setAttribute('aria-hidden', 'true');
        slot.parentNode.insertBefore(placeholder, slot);
      }
      body.appendChild(slot);
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
    }

    dialog._reviewsModalOpen = open;

    dialog.addEventListener('close', function () {
      if (placeholder && slot.parentNode === body) {
        placeholder.parentNode.insertBefore(slot, placeholder);
        placeholder.remove();
        placeholder = null;
      }
    });

    if (openBtn) {
      openBtn.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    }

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (dialog.open) dialog.close();
      });
    });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
  }

  /**
   * recent-reviews section: .recent-reviews__btn opens the same dialog when it exists (product template).
   */
  function initRecentReviewsTriggers() {
    document.querySelectorAll('.recent-reviews__btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var dialog = document.querySelector('dialog.product-reviews-modal');
        if (!dialog || typeof dialog._reviewsModalOpen !== 'function') return;
        e.preventDefault();
        dialog._reviewsModalOpen();
      });
    });
  }

  function init() {
    document.querySelectorAll('dialog.product-reviews-modal').forEach(initDialog);
    initRecentReviewsTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
